<template lang="pug">
#usersContent
  .users(v-for="(user, index) in userList" :key="index")
    .list
      el-image(:src="circleUrl(user)")
        .userAvatar(slot="error") {{userName(user.userName)}}
      .name(:title="user.userName") {{ user.userName }}
      flowNodeStatus(:status="user.result" v-if="user.result")
      .approvalTime(v-if="user.approvalTime") 审批时间：{{user.approvalTime}}
    .comment(v-if="user.comment" class="el-icon-caret-right") {{user.comment}}
</template>

<script>
import { gettouxAvatar } from "@/CommonDP/utils";
import flowNodeStatus from '@/CommonDP/components/flowComponents/flowNodeStatus';

export default {
  components: { flowNodeStatus },
  props: {
    userList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      roleIcon: require("@/CommonDP/assets/doc/role.png")
    };
  },
  methods: {
    circleUrl(item) {
      return gettouxAvatar(item.userId);
    },
    errorHandler() {
      return true;
    },
    deleteUser(user) {
      if (this.disabled) {
        return;
      }
      this.$confirm(`确认${this.deleteToolTip(user)}:${user.name}?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      }).then(async () => {
        this.$emit("deleteUser", user);
      }).catch(() => {
        // this.$message.info("已取消");
      });
    },
    deleteToolTip(user) {
      const tipDescribe = {
        0: () => { return "删除人员"; },
        1: () => { return "删除系统角色"; },
        2: () => { return "删除专业角色"; },
        3: () => { return "删除项目角色"; }
      };
      return tipDescribe[user.type] ? tipDescribe[user.type]() : console.log("未配置");
    },
    userName(val) {
      return val.charAt(0) || "";
    }
  }

};
</script>

<style lang="scss" scoped>
#usersContent {
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .users {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .list {
    padding: 5px 10px;
    height: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 5px;

    .el-image {
      width: 20px;
      height: 20px;
      border-radius: 5px;
      object-fit: contain;
    }

    /deep/.userAvatar {
      line-height: 20px;
      font-size: 12px;
      border-radius: 5px;
      text-align: center;
      background-color: var(--theme-color);
      color: #fff;
    }

    .name {
      max-width: 70px;
      overflow: hidden;
      text-overflow:ellipsis;
      margin-left: 5px;
      white-space:nowrap;
      font-size: 12px;
      line-height: 28px;
    }

    .approvalTime {
      margin-left: auto;
    }

    i {
      margin-left: 5px;
      font-size: 14px;
      line-height: 28px;
      cursor: pointer;
    }

    .noClick {
      cursor: not-allowed;
    }
  }

  .users:hover {
    background-color: #ebeef5;
  }
}

.comment {
  margin-left: 35px;
  font-size: 12px;
  line-height: 28px;
}

.result {
  margin-left: 5px;
  padding: 5px;
  border-radius: 6px;
}

.type1,
.type3,
.type4 {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
}

.type2 {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
}

.type5 {
  background: #70737e;
  color: #fff;
}

.type0 {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
}
</style>
